<template>
  <div>
    <el-form
      ref="detailForm"
      class="detail-form"
      :style="maxHeight ? `max-height:${maxHeight}` : ''"
      label-width="100px"
    >
      <div v-if="showTitle" class="panel-title">ERP子单信息</div>
      <div :class="['panel-content', showTitle && 'pad-content']">
        <el-row>
          <el-col :span="12">
            <el-form-item label="ERP子单号">
              <span>{{ model.subOrder }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="价格规则">
              <span>{{ model.subOrderName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="售卖价格">
              <span>{{ parseFloat(model.settlePrice || 0) }} 元/{{ materialEntity.sellingType }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="子单状态">
              <span>{{ ['启用', '暂停'][model.subOrderStatus] }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="排期总量">
              <span v-if="model.scheduleNumber">{{ model.scheduleNumber }} CPM</span>
              <span v-else>-</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="赠送总量">
              <span v-if="model.giveNumber">{{ model.giveNumber }} CPM</span>
              <span v-else>-</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="CPD售卖天数">
              <span>{{ model.scheduleCpdNumber || '-' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="投放时间">
              <span>{{ model.scheduleStartTime }} ~ {{ model.scheduleEndTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="showTitle" class="panel-title">所属ERP订单</div>
      <div :class="['panel-content', showTitle && 'pad-content']">
        <el-row>
          <el-col :span="12">
            <el-form-item label="ERP订单号">
              <span>{{ model.orderNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="ERP订单名称">
              <span>{{ model.orderName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户">
              <span>{{ model.agentName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组织">
              <span>{{ model.orgName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="showTitle" class="panel-title">产品信息</div>
      <div :class="['panel-content', showTitle && 'pad-content']">
        <el-row>
          <el-col :span="12">
            <el-form-item label="ERP产品编码">
              <span>{{ materialEntity.materialCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="ERP产品名称">
              <span>{{ materialEntity.materialName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="售卖方式">
              <span>{{ materialEntity.sellingType }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="素材时长">
              <span>{{ materialEntity.showTime || 0 }} S</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="支持的广告位">
              <span>{{ spaceName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="showTitle" class="panel-title">溢价信息</div>
      <div :class="['panel-content', showTitle && 'pad-content']">
        <el-row>
          <el-col v-if="directionalModel.regional" :span="12">
            <el-form-item label="区域溢价">
              <span>{{ directionalModel.regional }}</span>
            </el-form-item>
          </el-col>
          <el-col v-if="directionalModel.timesegment" :span="12">
            <el-form-item label="时间段定向">
              <span>{{ directionalModel.timesegment }}</span>
            </el-form-item>
          </el-col>
          <el-col v-if="directionalModel.control" :span="12">
            <el-form-item label="频控定向">
              <span>{{ directionalModel.control }}</span>
            </el-form-item>
          </el-col>
          <el-col v-if="directionalModel.sizes" :span="12">
            <el-form-item label="尺寸定向">
              <span>{{ directionalModel.sizes }}</span>
            </el-form-item>
          </el-col>
          <el-col v-if="directionalModel.holiday" :span="12">
            <el-form-item label="节假日定向">
              <span>{{ directionalModel.holiday }}</span>
            </el-form-item>
          </el-col>
          <el-col v-if="directionalModel.crowdpack" :span="12">
            <el-form-item label="广告DMP">
              <span>{{ directionalModel.crowdpack }}</span>
            </el-form-item>
          </el-col>
          <el-col v-if="directionalModel.content" :span="12">
            <el-form-item label="内容定向">
              <span>{{ directionalModel.content }}</span>
            </el-form-item>
          </el-col>
          <el-col v-if="directionalModel.launch" :span="12">
            <el-form-item label="PDB投放">
              <span>{{ directionalModel.launch }}</span>
            </el-form-item>
          </el-col>
          <el-col v-if="directionalModel.screen" :span="12">
            <el-form-item label="屏幕类型">
              <span>{{ directionalModel.screen }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      default: () => {
        return {
          directionalModel: {},
          materialEntity: {}
        }
      }
    },
    spaceOptions: {
      type: Array,
      default: () => []
    },
    maxHeight: {
      type: String,
      default: ''
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    directionalModel() {
      return this.model.directionalModel
    },
    spaceName() {
      if (this.model.materialEntity.spaceNo === undefined || this.model.materialEntity.spaceNo === '0') {
        return '不限'
      }
      const spaceNos = this.model.materialEntity.spaceNo.split(',')
      return spaceNos
        .filter(spaceNo => spaceNo !== '')
        .map(spaceNo => {
          const space = this.spaceOptions.find(ele => ele.spaceNo === spaceNo)
          return space ? (space.label || space.spaceName) : ''
        }).join(',')
    },
    materialEntity() {
      return this.model.materialEntity || {}
    }
  }
}
</script>

<style lang="stylus" scoped>
.detail-form
  overflow auto
.panel-title
  font-size 14px
  font-weight 600
  color #333
.panel-content .el-form-item
  margin-bottom 0
  >>>.el-form-item__label
    color #888
  >>>.el-form-item__content>span
    color #333
.pad-content
  padding 10px
</style>
